<template>
    <b-modal :id="'modal-deletar-usuario-' + usuarioSelecionado.id" hide-footer centered title="Excluir Usuário">
        <div v-if="usuarioSelecionado != null">
            <b-col md="12" class="d-flex gap-sm">
                <strong>Nome: </strong>
                <span>{{ usuarioSelecionado.nome ? usuarioSelecionado.nome : usuario.razaoSocial }}</span>
            </b-col>
            <b-col md="12" class="d-flex gap-sm">
                <strong>Email: </strong>
                <span>{{ usuarioSelecionado.email }}</span>
            </b-col>
        </div>
        <div class="d-flex mt-5">
            <b-button variant="outline-danger" class="mx-auto" :disabled="carregando" @click="excluirUsuario">
                <b-spinner class="align-middle" variant="danger" v-if="carregando"></b-spinner>
                <span v-if="!carregando">
                    Excluir
                </span>
            </b-button>
        </div>

    </b-modal>
</template>

<script>
import AuthService from "../../service/AuthService.js";

export default {
	name: "ModalExcluirUsuario",
	props: [ "usuario" ],
	data() {
		return {
			usuarioSelecionado: this.usuario,
			carregando: false,
		};
	},
	methods: {

		excluirUsuario() {
			this.carregando = true;

			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			AuthService.excluirUsuario(this.usuarioSelecionado.id, usuarioLogado.id)
				.then(() => {
					this.mensagem("Usuário excluido com sucesso", "Sucesso", "success");
				})
				.then(() => {
					this.$emit("sucesso");
				})
				.catch(() => {
					this.mensagem("Não foi possível excluir o usuário", "Erro", "danger");
				})
				.finally(() => {
					this.carregando = false;
					this.$bvModal.hide("modal-deletar-usuario-" + this.usuarioSelecionado.id);
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/usuario/ModalExcluirUsuario.vue